import { TableSkeleton } from '@components/medicus-ui/Loaders';
import { EstadoLegajoBadge } from '@components/EstadoLegajoBadge';
import { estadoReportePadronInfo } from '@lib/estado-reporte-padron';
import type { ReportePadronRow } from '@lib/services/reportePadron';

interface TablaProps {
  rows: ReportePadronRow[];
  loading?: boolean;
}

/**
 * `aaaa-mm-dd` → `dd/mm/aaaa`. La fecha de carga ya viene como día de
 * Argentina desde el server; pasarla por `Date` la correría un día para atrás
 * en el navegador (UTC-3).
 */
function fechaCarga(dia: string | null): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dia ?? '');
  return m ? `${m[3]}/${m[2]}/${m[1]}` : '—';
}

export function ReportePadronTabla({ rows, loading }: TablaProps) {
  if (loading) return <TableSkeleton rows={6} />;

  if (rows.length === 0) {
    return (
      <p className="text-element-mid">No se encontraron personas con los filtros seleccionados.</p>
    );
  }

  return (
    <div className="tableWrap">
      <table className="dataTable">
        <thead>
          <tr>
            <th>Legajo</th>
            <th>DNI</th>
            <th>CUIL</th>
            <th>Nombre / Apellido</th>
            <th>Parentesco</th>
            <th>Estado</th>
            <th>Fecha de carga</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={`${r.legajoId}:${r.asociadoId}`}>
              <td style={{ fontWeight: 600 }}>{r.legajo || '—'}</td>
              <td>{r.dni || '—'}</td>
              <td>{r.cuil || '—'}</td>
              <td style={{ fontWeight: 500 }}>{r.nombre}</td>
              <td>{r.parentesco}</td>
              <td>
                <EstadoLegajoBadge
                  estado={r.estado}
                  info={estadoReportePadronInfo(r.estado, r.estadoLabel)}
                />
              </td>
              <td>{fechaCarga(r.fechaCarga)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
